module.exports = __webpack_public_path__ + "static/media/otc-logo.d2551076.png";